import type { ButtonHTMLAttributes, ReactNode } from 'react'

type Variant = 'primary' | 'ghost' | 'danger' | 'plain'

const VARIANT_CLASS: Record<Variant, string> = {
  primary: 'btn--primary',
  ghost: 'btn--ghost',
  danger: 'btn--danger',
  plain: ''
}

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  variant?: Variant
  size?: 'sm'
  /** Идёт запрос: кнопка блокируется и получает спиннер перед подписью. */
  busy?: boolean
  block?: boolean
  children: ReactNode
}

/**
 * Кнопка бекофиса поверх классов .btn/.btn--primary/…
 * `busy` заменяет связку «disabled + <span className="spin" />», которая
 * повторялась в формах 42 раза.
 */
export function Button({
  variant = 'plain',
  size,
  busy,
  block,
  disabled,
  className,
  children,
  type = 'button',
  ...rest
}: ButtonProps): React.JSX.Element {
  const cls = [
    'btn',
    VARIANT_CLASS[variant],
    size === 'sm' ? 'btn--sm' : '',
    block ? 'btn--block' : '',
    className ?? ''
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button className={cls} type={type} disabled={disabled || busy} {...rest}>
      {busy && <span className="spin" />}
      {children}
    </button>
  )
}

/** Иконочная кнопка строки таблицы (карандаш/корзина). */
export function IconButton({
  danger,
  className,
  children,
  type = 'button',
  ...rest
}: Omit<ButtonProps, 'variant' | 'size' | 'busy' | 'block'> & {
  danger?: boolean
}): React.JSX.Element {
  const cls = ['icon-btn', danger ? 'icon-btn--danger' : '', className ?? '']
    .filter(Boolean)
    .join(' ')
  return (
    <button className={cls} type={type} {...rest}>
      {children}
    </button>
  )
}
